wbApp.controller('EmailTemplatesDetailCtrl', ['$scope', '$translate', '$filter', 
function ($scope, $translate, $filter) {

    $scope.detailTabs = [
    {
        title: 'TXT_LBL_EMAIL',
        template: "messages/email-templates-preview-detail-email-tab.html"
    }, {
        title: 'TXT_SEC_VALIDATE',
        template: "messages/email-templates-preview-detail-errors-tab.html"
    }];

    $scope.detail.$promise.then(function (model) {
        $scope.validationErrors = model.validationErrors;
        $scope.isValid = model.isValid;
        if (!$scope.isValid) {
            $scope.detailTabs.activeTab = 1;
        }
        $("#email-content-iframe").contents().find('html').html(model.htmlBody);
    });


}]);
